module.exports = __webpack_public_path__ + "static/media/menu.a450cc10.svg";